// 需要使用低版本crypto-js并按需引入，否则子依赖包含node兼容代码，会很大
import AES from "crypto-js/aes";
import Utf8 from "crypto-js/enc-utf8";
import ECB from "crypto-js/mode-ecb";
import Pkcs7 from "crypto-js/pad-pkcs7";
import Util from "@/_utils/util"

function decrypt(words, key) {
    var utf8key = Utf8.parse(key)
    var decrypted = AES.decrypt(words, utf8key, {
        mode: ECB,
        padding: Pkcs7,
    });
    return Utf8.stringify(decrypted).toString();
}
// 解密图片、图片占位
function initImg(originImgs,maxWidth=640) {
    try {
        var imgList = document.querySelectorAll('.text img[data-src]');
        imgList.forEach((item)=>{
            var imgSrc = item.getAttribute('data-src');
            if (!!imgSrc) {
                var decryptImgSrc = decrypt(imgSrc, 'www.sohu.com6666');
                console.log('解密图', decryptImgSrc);
                item.setAttribute('data-src', decryptImgSrc);
                const originImg = originImgs.find((item)=>{
                    return item.url == decryptImgSrc
                })
                var originalWidth = originImg?.width;
                var originalHeight = originImg?.height;

                let renderedWidth = originalWidth
                let renderedHeight = originalHeight

                // 图片实际宽度 > maxWidth时进行缩放处理
                if(originalWidth > maxWidth) {
                    const widthScale = maxWidth / originalWidth; // 计算缩放比例
                    const scale = widthScale; // 因为容器高度不限，只考虑宽度缩放
                    renderedWidth = Math.round(originalWidth * scale);    // 计算渲染后的宽度
                    renderedHeight = Math.round(originalHeight * scale);  // 计算渲染后的高度
                }

                item.setAttribute('width', renderedWidth);
                item.setAttribute('height', renderedHeight);

            }
        })
    } catch (error) {
        console.log('解密图片、图片占位',error)
    }
}
// true-默认解密
function changeImg(decryptStatus=true) {
    //	获取正文img
    var imgList = document.querySelectorAll('.text img[data-src]');
    var windowHeight = window.innerHeight
    var heightList = [];
    //	获取img所在位置-50
    for (var i = 0; i < (imgList && imgList.length); i++) {
        heightList.push(imgList[i]?.getBoundingClientRect()?.top + window.scrollY - windowHeight - 50)
    }
    var scrollY = window.scrollY || document.documentElement.scrollTop
    for (var i = 0; i < (heightList && heightList.length); i++) {
        // 滑到图片上方50位置时，加载
        if (scrollY >= heightList[i]) {
            var imgSrc = imgList[i].getAttribute('data-src');
            if (!!imgSrc) {
                var decryptImgSrc = !decryptStatus ? imgSrc : decrypt(imgSrc, 'www.sohu.com6666');
                imgList[i].removeAttribute('data-src');
                imgList[i].setAttribute('src', decryptImgSrc);
            }
        }
    }
}

function getArticleImg(decryptStatus) {
    changeImg(decryptStatus);
    window.addEventListener('scroll', Util.throttle(()=>{
        changeImg(decryptStatus);
    },300));

}


export {
    getArticleImg,
    initImg
}